export const MAX_SPLIT_CHILD_PROJECTILES = 2;

export interface SplitSpawnBudget {
  readonly count: number;
  readonly damageMultiplierScale: number;
}

export function resolveSplitSpawnBudget(
  plannedChildren: number,
  remainingSlots: number,
  cap = MAX_SPLIT_CHILD_PROJECTILES,
): SplitSpawnBudget {
  const planned = Math.max(0, Math.floor(plannedChildren));
  const slots = Math.max(0, Math.floor(remainingSlots));
  const limit = Math.max(0, Math.floor(cap));
  const count = Math.min(planned, slots, limit);
  return {
    count,
    damageMultiplierScale: count > 0 ? planned / count : 1,
  };
}
